import * as stockApi from '@/api/stock';

export default {
    namespaced: true,
    state: () => ({
        brands: [],
        productTypes: [],
        productModels: [],
        products: [],
        locations: [],
        suppliers: [],
        loading: {
            brands: false,
            productTypes: false,
            productModels: false,
            products: false,
            locations: false,
            suppliers: false,
        },
        // ── Dashboard stats ──
        dashboardStats: null,
    }),
    getters: {
        brandById: (state) => (id) => state.brands.find(b => b.id === id),
        productById: (state) => (id) => state.products.find(p => p.id === id),
        locationById: (state) => (id) => state.locations.find(l => l.id === id),
        dashboardStats: (state) => state.dashboardStats,
    },
    mutations: {
        SET_BRANDS(state, brands) { state.brands = brands; },
        SET_PRODUCT_TYPES(state, types) { state.productTypes = types; },
        SET_PRODUCT_MODELS(state, models) { state.productModels = models; },
        SET_PRODUCTS(state, products) { state.products = products; },
        SET_LOCATIONS(state, locations) { state.locations = locations; },
        SET_SUPPLIERS(state, suppliers) { state.suppliers = suppliers; },
        SET_LOADING(state, { key, value }) { state.loading[key] = value; },
        // ── Dashboard stats ──
        SET_DASHBOARD_STATS(state, stats) {
            state.dashboardStats = stats;
        },
        CLEAR_DASHBOARD_CACHE(state) {
            state.dashboardStats = null;
        },
    },
    actions: {
        async fetchBrands({ commit }) {
            commit('SET_LOADING', { key: 'brands', value: true });
            try {
                const res = await stockApi.brandsApi.list({ per_page: 500 });
                commit('SET_BRANDS', res.data || res || []);
            } finally {
                commit('SET_LOADING', { key: 'brands', value: false });
            }
        },
        async fetchProductTypes({ commit }) {
            commit('SET_LOADING', { key: 'productTypes', value: true });
            try {
                const res = await stockApi.productTypesApi.list();
                commit('SET_PRODUCT_TYPES', res.data || res || []);
            } finally {
                commit('SET_LOADING', { key: 'productTypes', value: false });
            }
        },
        async fetchProductModels({ commit }) {
            commit('SET_LOADING', { key: 'productModels', value: true });
            try {
                const res = await stockApi.productModelsApi.list({ per_page: 500 });
                commit('SET_PRODUCT_MODELS', res.data || res || []);
            } finally {
                commit('SET_LOADING', { key: 'productModels', value: false });
            }
        },
        async fetchLocations({ commit }) {
            commit('SET_LOADING', { key: 'locations', value: true });
            try {
                const res = await stockApi.locationsApi.list();
                commit('SET_LOCATIONS', res.data || res || []);
            } finally {
                commit('SET_LOADING', { key: 'locations', value: false });
            }
        },
        async fetchSuppliers({ commit }) {
            commit('SET_LOADING', { key: 'suppliers', value: true });
            try {
                const res = await stockApi.listFournisseurComptes({ limit: 500 });
                commit('SET_SUPPLIERS', res.data || res || []);
            } finally {
                commit('SET_LOADING', { key: 'suppliers', value: false });
            }
        },
    },
};
